const State = {
  visitedViews: [],
  cachedViews: [],
  closedViews: []
};

// getters
const Getters = {
  visitedViews: state => state.visitedViews,
  cachedViews: state => state.cachedViews,
  closedViews: state => state.closedViews,
};

// mutations
const Mutations = {
  ADD_CLOSED_VIEW: (state, view) => {
    state.closedViews.push(view.name);
  },
  DELETE_CLOSED_VIEW: (state) => {
    state.closedViews = [];
  },
  ADD_VISITED_VIEW: (state, view) => {
    if (state.visitedViews.some(v => v.path === view.path)) return;
    let title = view.meta.title || 'no-name';
    if (view.meta.type) {
      title = view.meta.type[view.params.id].name;
    }
    state.visitedViews.push(
      Object.assign({}, view, {title})
    );
  },
  ADD_CACHED_VIEW: (state, view) => {
    if (state.cachedViews.includes(view.name)) return;
    if (!view.meta.noCache) {
      state.cachedViews.push(view.name);
    }
  },

  DEL_VISITED_VIEW: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1);
        break;
      }
    }
  },
  DEL_CACHED_VIEW: (state, view) => {
    for (const i of state.cachedViews) {
      if (i === view.name) {
        const index = state.cachedViews.indexOf(i);
        state.cachedViews.splice(index, 1);
        break;
      }
    }
    //如果没有customerService下的子标签，删除customerService组件
    let retain = ['billLading'], re = true;
    retain.forEach(v => {
      state.cachedViews.indexOf(v) > -1 ? re = false : '';
    });
    if (re) state.cachedViews.splice(state.cachedViews.indexOf('customerService'), 1);
  },

  DEL_OTHERS_VISITED_VIEWS: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews = state.visitedViews.slice(i, i + 1);
        break;
      }
    }
  },
  DEL_OTHERS_CACHED_VIEWS: (state, view) => {
    for (const i of state.cachedViews) {
      if (i === view.name) {
        const index = state.cachedViews.indexOf(i);
        state.cachedViews = state.cachedViews.slice(index, index + 1);
        break;
      }
    }
  },

  DEL_ALL_VISITED_VIEWS: state => {
    state.visitedViews = [];
  },
  DEL_ALL_CACHED_VIEWS: state => {
    state.cachedViews = [];
  },

  UPDATE_VISITED_VIEW: (state, view) => {
    for (let v of state.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view);
        break;
      }
    }
  }
};
// actions
const Actions = {
  addClosedView({commit, dispatch}, view) {
    commit('ADD_CLOSED_VIEW', view);
    setTimeout(function () {
      dispatch('deleteClosedView', view);
    }, 1000);
  },
  deleteClosedView({commit}, view) {
    commit('DELETE_CLOSED_VIEW', view);
  },
  addView({dispatch}, view) {
    if (view.name === 'login' || view.name === 'servicelogin') return;
    dispatch('addVisitedView', view);
    dispatch('addCachedView', view);
  },
  addVisitedView({commit}, view) {
    commit('ADD_VISITED_VIEW', view);
  },
  addCachedView({commit}, view) {
    commit('ADD_CACHED_VIEW', view);
  },

  delView({dispatch, state}, view) {
    return new Promise(resolve => {
      dispatch('delVisitedView', view);
      dispatch('delCachedView', view);
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      });
    });
  },
  delVisitedView({commit, state}, view) {
    return new Promise(resolve => {
      commit('DEL_VISITED_VIEW', view);
      resolve([...state.visitedViews]);
    });
  },
  delCachedView({commit, state}, view) {
    return new Promise(resolve => {
      commit('DEL_CACHED_VIEW', view);
      resolve([...state.cachedViews]);
    });
  },

  delOthersViews({dispatch, state}, view) {
    return new Promise(resolve => {
      dispatch('delOthersVisitedViews', view);
      dispatch('delOthersCachedViews', view);
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      });
    });
  },
  delOthersVisitedViews({commit, state}, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_VISITED_VIEWS', view);
      resolve([...state.visitedViews]);
    });
  },
  delOthersCachedViews({commit, state}, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_CACHED_VIEWS', view);
      resolve([...state.cachedViews]);
    });
  },

  delAllViews({dispatch, state}, view) {
    return new Promise(resolve => {
      dispatch('delAllVisitedViews', view);
      dispatch('delAllCachedViews', view);
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      });
    });
  },
  delAllVisitedViews({commit, state}) {
    return new Promise(resolve => {
      commit('DEL_ALL_VISITED_VIEWS');
      resolve([...state.visitedViews]);
    });
  },
  delAllCachedViews({commit, state}) {
    return new Promise(resolve => {
      commit('DEL_ALL_CACHED_VIEWS');
      resolve([...state.cachedViews]);
    });
  },
  updateVisitedView({commit}, view) {
    commit('UPDATE_VISITED_VIEW', view);
  }
};

export default {
  namespaced: true,
  strict: true,
  state: State,
  getters: Getters,
  actions: Actions,
  mutations: Mutations
};
